<script>
export default {
  name: "DetalleGuarda",
  props: {
    datosGuarda: Object,
    observaciones: String,
  }
}
</script>

<template>
  <div class="mt-2">
    <b-row>
      <b-col style="line-height: 2.4">
        <span> <strong>Tipo de Guarda: </strong> {{datosGuarda.tipoGuarda }} </span>
      </b-col>
    </b-row>

    <b-row v-if="datosGuarda.tipoRecorte !== null">
      <b-col style="line-height: 2.4">
        <span><strong>Recorte: </strong> {{datosGuarda.tipoRecorte}} </span>
      </b-col>
    </b-row>

    <b-row v-if="datosGuarda.tipoCalibre !== null">
      <b-col style="line-height: 2.4">
        <span><strong>Calibre: </strong> {{datosGuarda.tipoCalibre}} </span>
      </b-col>
    </b-row>

    <b-row v-if="datosGuarda.tipoAcrilico !== null">
      <b-col style="line-height: 2.4">
        <span><strong>Tipo de Acrilico: </strong> {{datosGuarda.tipoAcrilico}} </span>
      </b-col>
    </b-row>
  </div>
</template>

<style scoped>

</style>
